import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { isShipmentAdjustable } from 'profile/clubMembership/shipment/components/traditional/helpers';

import ClubShipDate from '../shipment/components/traditional/ClubShipDate';

const TraditionalShipment = (props) => {
  const { clubMembership } = props;

  const clubPackageReducer = useSelector((state) => state.clubPackage);
  const clubMemberShipmentReducer = useSelector(
    (state) => state.clubMemberShipment
  );
  const settings = useSelector((state) => state.setting);
  let clubPackage;
  let clubMemberShipment;
  if (clubMembership.activeClubPackageId) {
    clubPackage = clubPackageReducer.data[clubMembership.activeClubPackageId];
    clubMemberShipment =
      clubMemberShipmentReducer.data[clubMembership.activeClubMemberShipmentId];
  }
  if (!clubPackage) {
    return (
      <Link
        to={`/profile/club-membership/${clubMembership.id}`}
        className="c7-button-alt-small"
      >
        Edit
      </Link>
    );
  }
  return (
    <div className="c7-account-tile__section__club-shipment">
      <br />
      <ClubShipDate
        clubMemberShipment={clubMemberShipment}
        clubPackage={clubPackage}
        settings={settings}
      />
      <br />
      {renderItems(clubMemberShipment.items, clubPackage)}
      {isShipmentAdjustable(clubMemberShipment, clubPackage) && (
        <Link
          to={`/profile/club-membership/${clubMembership.id}/shipment`}
          className="c7-button-alt-small c7-button-alt-small--adjust"
        >
          Adjust
        </Link>
      )}
      {!isShipmentAdjustable(clubMemberShipment, clubPackage) && (
        <Link
          to={`/profile/club-membership/${clubMembership.id}`}
          className="c7-button-alt-small"
        >
          Edit
        </Link>
      )}
    </div>
  );
};

const renderItems = (items, clubPackage) =>
  items.map((item) => {
    const productTitle = getProductTitle(clubPackage, item.productVariantId);
    return (
      <Fragment key={item.id}>
        <span className="c7-account-tile__section__club-shipment__item">
          {item.quantity} of {productTitle}
        </span>
      </Fragment>
    );
  });

const getProductTitle = (clubPackage, productVariantId) => {
  const product = clubPackage.items.find(
    (item) => item.productVariantId === productVariantId
  );
  return product.productTitle;
};

export default TraditionalShipment;
